<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-1 mr-2"
        color="info"
        v-on="on"
      >
        Edit
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Course Material"
      text="Edit Course Materials"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="description"
                v-validate="'required'"
                :error-messages="errors.collect('description')"
                data-vv-name="description"                
                label="Description"
              />
            </v-col>
            <v-col v-if="course.course_material_type.extension ==='link'">
              <v-btn @click="addRow">
                Add Link
              </v-btn>
                   
              <v-row
                v-for="(link, counter) in links"
                :key="counter"
              >
                <v-col
                  cols="10"
                  class="py-0"
                >
                  <v-text-field
                    v-model="link.path"
                    v-validate="'required'"
                    :error-messages="errors.collect('link')"
                    data-vv-name="link"                
                    label="Link"
                  />
                </v-col>
                <v-col
                  cols="2"
                  class="py-0 center-icon"
                >
                  <v-icon
                    color="error"
                    @click="deleteRow(counter)"
                  >
                    mdi-window-close
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              v-else
              cols="12"
            >
              <helper-file-input
                v-model="file"
                :max-size-in-mb="fileSize"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                :accept-type="course.course_material_type.extension"
              >
                <div
                  slot="activator"
                  class="mb-2"
                >
                  <v-btn
                    :disabled="progressing"
                    class="mx-2"
                  >
                    Add file
                  </v-btn>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          v-if="course.course_material_type.extension ==='link'"
          :loading="progressing"
          color="success"
          @click="submitFormVideo"
        >
          Save Changes
        </v-btn>

        <v-btn
          v-else
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Save Changes
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    inject: ['$validator'],
    props: {
      course: {
        type: Object,
        default: null,
      },
    },
 
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        description: null,
        materialTypes: null,
        courseMaterialTypes: [],
        file: null,
        links: [
          {
            path: null,
          },
        ],
      }
    },

    computed: {
      fileSize () {
        if (
          this.course.course_material_type.extension === '.pdf' ||
          this.course.course_material_type.extension === '.jpg,.jpeg,.png'
        ) {
          return 2
        }
        return 10
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.resetForm()
        this.loadData()
      },
    },
    methods: {
      addRow () {
        this.links.push({
          path: '',
        })
      },
      deleteRow (counter) {
        this.links.splice(counter, 1)
      },

      loadData () {
        this.name = this.course.name
        this.description = this.course.description
      },

      prepareFormDataVideo () {
        return {
          name: this.name,
          description: this.description,
          course_material_type_id: this.course.course_material_type.id,
          links: this.links,
        }
      },

      submitFormVideo () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.prepareFormDataVideo()
            this.progressing = true

            this.$api.courseMaterials().update(this.course.id, this.prepareFormDataVideo())
              .then((res) => {
                if (res.status === 200) {
                  this.$emit('updated', res.data)                
                  this.$snack({ message: 'Course Material Updated Succesfully' })

                  this.dialog = false                
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      submitForm () {
        this.$validator.validateAll().then(result => {
          if (!result) return

          this.progressing = true

          this.$api
            .courseMaterials()
            .update(this.course.id, this.prepareFormData())
            .then(res => {
              if (res.status === 200) {
                this.$emit('updated')
                this.$snack({ message: 'Course Material Updated Succesfully' })

                this.dialog = false
              }
            })
            .catch(() => {})
            .then(() => {
              this.progressing = false
            })
        })
      },

      prepareFormData () {
        if (this.file) {
          this.file.formData.append('name', this.name)
          this.file.formData.append('description', this.description)
          this.file.formData.append(
            'course_material_type_id',
            this.course.course_material_type.id
          )
          return this.file.formData
        }

        return {
          name: this.name,
          description: this.description,
          course_material_type_id: this.course.course_material_type.id,
        }
      },

      resetForm () {
        this.name = null
        this.description = null
        this.file = null
        this.links.map(item => {
          item.path = null
        })
        this.$validator.reset()
      },
    },
  }
</script>

<style scoped>
.center-icon{
    margin:auto
}

.text-ellipsis{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
</style>
